<template>
  <el-menu :router="true">
    <el-menu-item v-for="item in filteredSideMenuList" :key="item.id" :id="item.id" :route="item.route" :index="item.subject">
      <template slot="title">
        <fa class="menu-item-icon" :icon="item.icon"></fa>
        {{ item.name }}
      </template>
    </el-menu-item>
  </el-menu>
</template>

<script>
import { FontAwesomeIcon as fa } from "@fortawesome/vue-fontawesome";
import { faUserTie, faUser, faVideo, faServer, faSortAmountDown, faWallet, faMoneyCheckAlt, faPassport, faChartBar } from "@fortawesome/free-solid-svg-icons";

const sideMenuList = [
  {
    id: "listCameras",
    name: "Камеры",
    route: { name: "cameras", params: { page: 1 } },
    subject: "cameras",
    icon: faVideo,
  },
  {
    id: "intercoms",
    name: "Домофоны",
    route: { name: "intercoms", params: { page: 1 } },
    subject: "intercoms",
    icon: faServer,
  },
  {
    id: "listServers",
    name: "DVR серверы",
    route: { name: "servers", params: { page: 1 } },
    subject: "dvr_servers",
    icon: faServer,
  },
  {
    id: "camerasPriority",
    name: "Приоритет камер",
    route: { name: "priority", params: { page: 1 } },
    subject: "cameras_priorities_transactions",
    icon: faSortAmountDown,
  },
  {
    id: "listUsers",
    name: "Сотрудники",
    route: { name: "users", params: { page: 1 } },
    subject: "employees",
    icon: faUserTie,
  },
  {
    id: "listClients",
    name: "Клиенты",
    route: { name: "clients", params: { page: 1 } },
    subject: "clients",
    icon: faUser,
  },
  {
    id: "listTariffs",
    name: "Тарифы",
    route: { name: "tariffs" },
    subject: "tariffs",
    icon: faWallet,
  },
  {
    id: "billing",
    name: "Биллинг",
    route: { name: "billing" },
    subject: "billing",
    icon: faMoneyCheckAlt,
  },
  {
    id: "listOrgs",
    name: "Юридические лица",
    route: { name: "orgs", params: { page: 1 } },
    subject: "orgs",
    icon: faPassport,
  },
  {
    id: "listSipServers",
    name: "SIP-серверы",
    route: { name: "sip-servers", params: { page: 1 } },
    subject: "sip_servers",
    icon: faServer,
  },
  {
    id: "camerasMonitoring",
    name: "Мониторинг",
    route: { name: "cameras:monitoring" },
    subject: "cameras_state",
    icon: faChartBar,
  },
];

export default {
  name: "SideMenu",
  components: { fa },
  computed: {
    filteredSideMenuList() {
      return sideMenuList.filter(({ subject }) => this.$can("read", subject))
        .filter(({ subject }) => !(subject == "intercoms" && localStorage.getItem("operator") != 621
          && localStorage.getItem("operator") != 2
          && localStorage.getItem("operator") != 1021))
        /* ^ костыль, чтобы показывать вкладку домофонов только для Провзора(621) и vcrftest(1021). Нужно переделать, когда будет горизонтальное разграничение прав. */
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu {
  height: calc(100% - 60px);
}
.menu-item-icon {
  width: 20px;
  text-align: center;
  margin-right: 15px;
}
</style>
